function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    style: {
      fill: "none",
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44 3.41a.94.94 0 0 1 .33.33.85.85 0 0 1 .12.44.87.87 0 0 1-.12.45.91.91 0 0 1-.33.37.87.87 0 0 1-.44.08.88.88 0 0 1-.45-.08.87.87 0 0 1-.33-.33.88.88 0 0 1-.12-.45.87.87 0 0 1 .12-.44.91.91 0 0 1 .33-.33.87.87 0 0 1 .45-.16.85.85 0 0 1 .44.12Zm.39 9.9a.6.6 0 0 0 .33.31 1.78 1.78 0 0 0 .63.09V14l-1.7-.05L7.4 14v-.29a1.78 1.78 0 0 0 .6-.09.6.6 0 0 0 .33-.31 1.42 1.42 0 0 0 .11-.61V8.32a1.51 1.51 0 0 0-.24-.94 1 1 0 0 0-.83-.29v-.3h.87A4.64 4.64 0 0 0 9.7 6.6v6.1a1.42 1.42 0 0 0 .13.61Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgInfo;